

import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.min.css'
import store from './store'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(ToastPlugin)
Vue.use(ToastPlugin, { position: 'top' })

import LoadingPlugin from 'vux/src/plugins/loading/index.js'

Vue.use(LoadingPlugin)

Vue.config.productionTip = false
Vue.prototype.$apiUrl = "/api.php"
Vue.prototype.$appUrl = "https://static.badyun.cc"
Vue.use(ElementUI);
/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js